import React from "react";
import PropTypes from "prop-types";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {Link} from "react-router-dom";
import "./style.scss";

export const RouterLinkMenuItem = ({selected, onClick, to, primary, secondary, iconLeft, iconRight, disabled}) => (
  <Link disabled={disabled} to={to}>
    <ListItem disabled={disabled} selected={selected} button onClick={onClick}>
      {iconLeft ? <ListItemIcon>{iconLeft}</ListItemIcon> : null}
      <ListItemText primary={primary} secondary={secondary} />
      {iconRight ? <ListItemIcon>{iconRight}</ListItemIcon> : null}
    </ListItem>
  </Link>
);

export const HrefLinkMenuItem = ({
  selected,
  onClick,
  href,
  primary,
  secondary,
  iconLeft,
  iconRight,
  disabled,
  ...rest
}) => {
  if (disabled) {
    return (
      <ListItem button disabled={disabled} onClick={onClick}>
        {iconLeft ? <ListItemIcon>{iconLeft}</ListItemIcon> : null}
        <ListItemText primary={primary} secondary={secondary} />
        {iconRight ? <ListItemIcon>{iconRight}</ListItemIcon> : null}
      </ListItem>
    );
  } else {
    return (
      <a {...rest} href={href} className="linkMenuItem accountDropdownItem">
        <ListItem button disabled={disabled} onClick={onClick}>
          {iconLeft ? <ListItemIcon>{iconLeft}</ListItemIcon> : null}
          <ListItemText primary={primary} secondary={secondary} />
          {iconRight ? <ListItemIcon>{iconRight}</ListItemIcon> : null}
        </ListItem>
      </a>
    );
  }
};

export const ClickLinkMenuItem = ({selected, onClick, primary, secondary, iconLeft, iconRight, disabled, ...rest}) => (
  <ListItem button disabled={disabled} onClick={onClick}>
    {iconLeft ? <ListItemIcon>{iconLeft}</ListItemIcon> : null}
    <ListItemText primary={primary} secondary={secondary} />
    {iconRight ? <ListItemIcon>{iconRight}</ListItemIcon> : null}
  </ListItem>
);

const LinkMenuItem = ({to, href, ...rest}) => {
  if (to) {
    return <RouterLinkMenuItem to={to} {...rest} />;
  } else if (href) {
    return <HrefLinkMenuItem href={href} {...rest} />;
  } else {
    return <ClickLinkMenuItem {...rest} />;
  }
};

LinkMenuItem.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  selected: PropTypes.bool
};

export default LinkMenuItem;



// WEBPACK FOOTER //
// ./src/components/Sidebar/components/LinkMenuItem/index.jsx